<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'Direct'">
    <sbnb-direct-subnav></sbnb-direct-subnav>
  </sbnb-subnav>

  <main fxFlex [ngClass.lt-md]="{ mobile: true }" class="subnav__exists">
    <section>
      <app-feature-flag-tabs>
        <sbnb-page-header navTabs>
          <div fxLayout fxLayoutAlign="start center">
            <h2 class="nomargin" fxFlex>Overview</h2>
          </div>
        </sbnb-page-header>
        <div fxLayout fxLayoutAlign="start center">
          <h2 class="nomargin" fxFlex>Overview</h2>
        </div>
      </app-feature-flag-tabs>

      <div style="margin-bottom: 40px">
        <sbnb-helptext-wrapper [area]="'content'" [pageId]="'direct-dashboard'"></sbnb-helptext-wrapper>

        <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'direct-dashboard'"></sbnb-helptext-wrapper>
      </div>
    </section>

    <section>
      <mat-spinner *ngIf="!directDashboardService.status" diameter="24"></mat-spinner>
      <sbnb-direct-overview-setup-guide *ngIf="directDashboardService.steps?.length"></sbnb-direct-overview-setup-guide>
    </section>

    <section *ngIf="directDashboardService.showSites">
      <sbnb-direct-sites-list></sbnb-direct-sites-list>
    </section>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" title="Direct">
  <sbnb-direct-subnav></sbnb-direct-subnav>
</sbnb-mobile-sidebar>
